import React from 'react'
import GenericButton from '../GenericButton'
import { gettext } from 'ttag'

function getIcon (on: any) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (on) {
    return 'motion-sensor'
  }

  return 'motion-sensor'
}

interface OwnProps {
  children?: React.ReactNode
  onPress?: (...args: any[]) => any
}

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
type Props = OwnProps & typeof PresenceSensor.defaultProps

// @ts-expect-error ts-migrate(2339) FIXME: Property 'onLongPress' does not exist on type 'Pro... Remove this comment to see the full error message
export default function PresenceSensor ({ onPress, onLongPress, on, offline, text, connectionStatus, hide, hideButtonPress }: Props) {
  return (
    <GenericButton
      icon={getIcon(on)}
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ icon: string; text: any; iconOnColor: stri... Remove this comment to see the full error message
      text={text}
      iconOnColor="#365b69"
      connectionStatus={connectionStatus}
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      status={on ? gettext('Detected') : ''}
      on={on}
      onLongPress={onLongPress}
      offline={offline}
      onPress={onPress}
      hide={hide}
      hideButtonPress={hideButtonPress}
    />
  )
}

PresenceSensor.defaultProps = {
  children: null,
  onPress: () => { }
}
